import React, { useState, useEffect, useMemo } from 'react';
import { Navbar } from './Navbar';
import './LoadingScreen.css';

export const LoadingScreen = ({ onComplete, user, onSignInClick }) => {
  const [progress, setProgress] = useState(0);
  const [currentText, setCurrentText] = useState('Loading...');

  const loadingTexts = useMemo(() => [
    'Loading...',
    'Processing...',
    'Almost ready...'
  ], []);

  const [isFadingOut, setIsFadingOut] = useState(false);

  useEffect(() => {
    let hasCompleted = false;
    setProgress(0);

    // Smooth progress animation logic
    const interval = setInterval(() => {
      setProgress(prev => {
        // Increment progress faster to reduce wait time (Average ~7% per tick)
        const increment = Math.random() * 10 + 2;
        const newProgress = Math.min(prev + increment, 100);

        // Update text based on progress thresholds
        const textIndex = Math.min(Math.floor(newProgress / 35), loadingTexts.length - 1);
        setCurrentText(loadingTexts[textIndex]);

        // Completion check
        if (newProgress >= 100 && !hasCompleted) {
          hasCompleted = true;
          clearInterval(interval);

          setIsFadingOut(true); // Start fade out

          // Wait for fade animation (500ms) before unmounting
          setTimeout(() => {
            if (onComplete) onComplete();
          }, 500);

          return 100;
        }

        return newProgress;
      });
    }, 50); // Faster updates for smoother bar

    return () => clearInterval(interval);
  }, [onComplete, loadingTexts]);

  return (
    <div className={`loading-screen base-background ${isFadingOut ? 'fade-out' : ''}`}>
      <Navbar currentUser={user} onSignInClick={onSignInClick} />
      <div className="loading-content">
        <div className="brain-animation">
          <div className="concentric-circles">
            <div className="circle circle-1"></div>
            <div className="circle circle-2"></div>
            <div className="circle circle-3"></div>
            <div className="circle circle-4"></div>
          </div>

          <div className="brain-center">
            <div className="brain-icon">🧠</div>
          </div>
        </div>

        <div className="progress-section">
          <div className="progress-bar-container">
            <div
              className="progress-fill"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <div className="progress-percentage">{Math.round(progress)}%</div>
        </div>

        <div className="loading-text">{currentText}</div>

        <div className="dots-indicator">
          <div className="dot active"></div>
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>
      </div>

      <div className="footer-brand">
        <span>youdontknowyou.com</span>
      </div>
    </div>
  );
};